import { render, staticRenderFns } from "./ModalMenu.vue?vue&type=template&id=03dfd2c6&scoped=true"
import script from "./ModalMenu.vue?vue&type=script&lang=js"
export * from "./ModalMenu.vue?vue&type=script&lang=js"
import style0 from "./ModalMenu.vue?vue&type=style&index=0&id=03dfd2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dfd2c6",
  null
  
)

export default component.exports